module.exports = __webpack_public_path__ + "static/media/Profile.350a1b80.svg";